<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">{{ isEdit ? 'Edit' : 'Add' }} Customer Proficiency</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <!-- Add mode: choose which proficiency to grant. -->
    <div class="form-group" *ngIf="!isEdit">
      <label for="proficiencyInput">Proficiency *</label>
      <select class="custom-select" id="proficiencyInput"
              [(ngModel)]="selectedProficiencyId"
              [disabled]="loadingProficiencies || (proficiencyList.length === 0)">
        <option *ngFor="let proficiency of proficiencyList"
                [value]="proficiency.id">{{ proficiency.name }}</option>
        <option *ngIf="loadingProficiencies">Loading...</option>
        <option *ngIf="!loadingProficiencies && (proficiencyList.length === 0)">
          No proficiencies are configured
        </option>
      </select>
    </div>

    <!-- Edit mode: show the proficiency's details and current expiration. -->
    <ng-container *ngIf="isEdit">
      <div class="form-group">
        <p class="mb-0">
          Proficiency:
          <b>{{ customerProficiency.proficiency_name }}</b>
        </p>
        <p class="mb-0" *ngIf="customerProficiency.granting_document_id">
          Source Document:
          <b>{{ customerProficiency.granting_document_name }}</b>
        </p>
        <p class="mb-0" *ngIf="customerProficiency.created_by_id">
          Created By:
          <b>{{ customerProficiency.created_by_first_name }} {{ customerProficiency.created_by_last_name }}</b>
        </p>
        <p class="mb-0" *ngIf="customerProficiency.last_edited_by_id">
          Last Edited By:
          <b>{{ customerProficiency.last_edited_by_email }}</b>
        </p>
      </div>

      <div class="form-group">
        <p class="mb-0">
          Existing Expiration Date:
          <b *ngIf="!customerProficiency.expiration_date">None</b>
          <b *ngIf="customerProficiency.expiration_date">{{ dateStringFromISO8601(customerProficiency.expiration_date) }}</b>
        </p>
      </div>
    </ng-container>

    <div class="form-group">
      <label for="expirationInput">{{ isEdit ? 'New Expiration Date' : 'Expiration Date *' }}</label>
      <select class="custom-select" id="expirationInput"
              [(ngModel)]="expirationMode">
        <option value="never">Never Expires</option>
        <option value="1">After 1 year</option>
        <option value="2">After 2 years</option>
        <option value="3">After 3 years</option>
        <option value="date">On a specific date</option>
      </select>
    </div>

    <div class="form-group" *ngIf="expirationMode === 'date'">
      <label for="expirationDateInput">Specific Date *</label>
      <input type="date" class="form-control" id="expirationDateInput"
             [(ngModel)]="selectedExpirationDate">
    </div>

    <div class="alert alert-info" role="alert"
         *ngIf="isEdit && !accountService.getMyAccount().can_manage_customer_proficiencies">
      You do not have permission to modify customers' proficiencies.
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <!-- Edit mode: remove the proficiency entirely. -->
    <button type="button" class="btn btn-danger"
            *ngIf="isEdit && !loadingSubmit"
            [disabled]="!accountService.getMyAccount().can_manage_customer_proficiencies"
            [class.disabled]="!accountService.getMyAccount().can_manage_customer_proficiencies"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="isEdit && loadingSubmit">
      Loading...
    </button>

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>

    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            [disabled]="isSaveDisabled() || (isEdit && !accountService.getMyAccount().can_manage_customer_proficiencies)"
            [class.disabled]="isSaveDisabled() || (isEdit && !accountService.getMyAccount().can_manage_customer_proficiencies)"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
